import styled from "styled-components";
import Dialog from "@mui/material/Dialog";

import { breakpoints } from "@/styles/breakpoints";

export const StyledCustomerPreviewModal = styled(Dialog)`
    .dialog-paper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 400px;
        height: 100%;
        max-height: 430px;
        padding: 20px 20px 40px 20px;
        background: var(--color-white);
        border-radius: 14px;
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.15);

        .modalBody {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 60px 40px;
            @media ${breakpoints.xs} {
                padding: 0 30px 20px;
            }
        }
    }
`;
